const local = `/${localStorage.lang}`; // :lang or '' 多语言是否配置在路径中

const domain = (str) => {
  const port = window.location.port;
  if (window.location.hostname == "localhost") {
    return "";
  }
  const domain = window.location.hostname.split(".");
  // const port = window.location.port;
  // console.log("port" + port);
  if (domain.length <= 2) {
    return window.location.protocol + "//" + str + "." + domain.join(".") + `${port ? ":" + port : ""}`;
  } else {
    return (
      window.location.protocol +
      "//" +
      str +
      "." +
      [domain[domain.length - 2], domain[domain.length - 1]].join(".") +
      `${port ? ":" + port : ""}`
    );
  }
};

const route_map = {
  index: `${local}`,
  entry: `/`,
  login: `${domain("www")}${local}/login`,
  register: `${domain("www")}${local}/register`,
  forgot: `${local}/forgot`,
  reset: `${local}/reset`,

  app_tv: `${domain("www")}${local}/app_tv`,

  labs: `${local}/labs`,

  market: `${domain("www")}${local}/market`,
  otc: `${domain("www")}${local}/express`,
  c2c: `${domain("otc")}${local}`,
  trade: `${domain("www")}${local}/trade`,
  futures: `${domain("futures")}${local}/trade`,
  kol: `${domain("futures")}${local}/copy-trading`,
  innovation: `${domain("www")}${local}/innovation`,
  bonus: `${domain("activity")}${local}/bonus`,
  agent: `${domain("activity")}${local}/global-agent`,

  download: `${domain("www")}${local}/appDownload`,
  totalAssets: `${domain("www")}${local}/wallet/overview`,
  exchangeAccount: `${domain("www")}${local}/wallet/main`,
  otcAccount: `${domain("www")}${local}/wallet/funding`,
  coAccount: `${domain("futures")}${local}/wallet/futures`,

  exchangeOrder: `${domain("www")}${local}/order/exchange`,
  otcOrder: `${domain("www")}${local}/order/funding`,
  coOrder: `${domain("www")}${local}/order/futures`,
  message: `${domain("www")}${local}/mesage`,
  noticeInfo: `${domain("www")}${local}/noticeInfo`,
  personal_userManagement: `${domain("www")}${local}/my/userManagement`,
  myrate: `${domain("www")}${local}/myRate`,
  personal_leaglTenderSet: `${domain("www")}${local}/my/leaglTenderSet`,
  inviteFriends: `${domain("www")}${local}/inviteFriends`,
  personal_apiManagement: `${domain("www")}${local}/my/apiManagement`,

  cmsApply: `${domain("www")}${local}/support/listing`,
  agentApply:
    localStorage.lang == "zh_CN"
      ? `https://forms.gle/zU3rQyGG3T6aD24r5`
      : localStorage.lang == "zh_TW"
      ? "https://forms.gle/1bcmeWiSGjBHKRen7"
      : "https://forms.gle/2MJRwqqdSkdn5pubA",
  c2cApply: `${domain("otc")}${local}/companyApplication`,

  aboutUs: `${domain("www")}${local}/support/aboutus`,
  help:
    localStorage.lang == "zh_CN" ? "https://vooxhelp.zendesk.com/hc/zh-cn" : "https://vooxhelp.zendesk.com/hc/en-us",
  fee: `${domain("www")}${local}/support/fee`,

  agreement: `${domain("www")}${local}/support/useragreement`,
  privacy: `${domain("www")}${local}/support/privacypolicy`,
  disclaimer: `${domain("www")}${local}/support/AML`,
  official: `${domain("www")}${local}/official`,
};

const need_login = [];
console.log(route_map);
export default route_map;

export { need_login };
